import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Products from "../pages/products/page";
import ProductDetail from "../pages/product/page";
import Blog from "../pages/blog/page";
import BlogPost from "../pages/blog-post/page";

// Admin pages
import AdminLogin from "../pages/admin/login";
import AdminLayout from "../pages/admin/layout";
import AdminDashboard from "../pages/admin/dashboard/page";
import AdminProducts from "../pages/admin/products/page";
import AdminBlog from "../pages/admin/blog/page";
import AdminHomepage from "../pages/admin/homepage/page";
import AdminFaqs from "../pages/admin/faqs/page";
import AdminTestimonials from "../pages/admin/testimonials/page";
import AdminSettings from "../pages/admin/settings/page";
import { Navigate } from "react-router-dom";

const routes: RouteObject[] = [
  // ── Public routes ──────────────────────────────────
  { path: "/",              element: <Home /> },
  { path: "/products",      element: <Products /> },
  { path: "/product/:id",   element: <ProductDetail /> },
  { path: "/blog",          element: <Blog /> },
  { path: "/blog/:slug",    element: <BlogPost /> },

  // ── Admin routes ───────────────────────────────────
  { path: "/admin/login",   element: <AdminLogin /> },
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { index: true,              element: <Navigate to="/admin/dashboard" replace /> },
      { path: "dashboard",        element: <AdminDashboard /> },
      { path: "products",         element: <AdminProducts /> },
      { path: "blog",             element: <AdminBlog /> },
      { path: "homepage",         element: <AdminHomepage /> },
      { path: "faqs",             element: <AdminFaqs /> },
      { path: "testimonials",     element: <AdminTestimonials /> },
      { path: "settings",         element: <AdminSettings /> },
    ],
  },
  // Also accessible at /panel
  { path: "/panel",         element: <Navigate to="/admin" replace /> },
  { path: "/panel/*",       element: <Navigate to="/admin" replace /> },

  { path: "*",              element: <NotFound /> },
];

export default routes;
